import { JSX } from 'react';
import { SkeletonPulse } from '@bg-components/Skeleton';
import classes from './LobbySkeleton.module.scss';

export const LobbySkeleton = (): JSX.Element => (
    <div className={classes.list} data-qa="area-lobby">
        {Array(9)
            .fill(null)
            .map((_, index) => (
                <div key={index} className={classes.container}>
                    <SkeletonPulse className={classes.lobby} radius="5px" />
                </div>
            ))}
    </div>
);
